var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-matter-log-container" },
    [
      !_vm.addOrEditVisible
        ? _c("div", { staticStyle: { height: "100%" } }, [
            _c(
              "div",
              { staticClass: "wl-container" },
              [
                _c("NewComments", {
                  attrs: { messageType: _vm.messageType, siteId: _vm.siteId },
                }),
                _c(
                  "div",
                  { staticClass: "wl-content-container content-with-comments" },
                  [
                    _c("div", { staticClass: "search-line1" }, [
                      _c("ul", { staticClass: "tab-cls" }, [
                        _vm.getSite.hasInterim
                          ? _c(
                              "li",
                              {
                                class: _vm.active === "1" ? "active" : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleClick("1")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("COMMON_INTERIM")) +
                                    "\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "li",
                          {
                            class: _vm.active === "2" ? "active" : "",
                            on: {
                              click: function ($event) {
                                return _vm.handleClick("2")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("COMMON_FINAL")))]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          class: [
                            "clean-filter",
                            _vm.cleanFilterActive ? "clean-filter-active" : "",
                          ],
                          on: { click: _vm.clearFilter },
                        },
                        [
                          _c("img", {
                            staticClass: "table-setting-icon",
                            attrs: {
                              src: require("@/assets/img/icon-screen.svg"),
                            },
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("clear_filter")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "search-line2" }, [
                      _c(
                        "div",
                        { staticClass: "search-line2-left" },
                        _vm._l(_vm.statusDict, function (item) {
                          return _c("span", { key: item.key }, [
                            _c("img", {
                              staticClass: "status-icon",
                              attrs: {
                                src: _vm.getIconSvg(item.icon),
                                width: "100%",
                              },
                            }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t(item.label)) +
                                "\n                        "
                            ),
                          ])
                        }),
                        0
                      ),
                      _c(
                        "div",
                        { staticClass: "search-line2-right" },
                        [
                          _vm.getUser.userType == "1"
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "wl-green",
                                  attrs: { icon: "el-icon-plus" },
                                  on: { click: _vm.onAddShow },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("MATTER_ADD_ITEM")) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.getUser.userType == "1"
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "wl-green svg-btn",
                                  attrs: { disabled: _vm.batch.show },
                                  on: { click: _vm.onBatchDeleteClick },
                                },
                                [
                                  _c("img", {
                                    staticClass: "btn-icon",
                                    attrs: {
                                      src: require("@/assets/img/icon-batchdeletion.svg"),
                                      width: "100%",
                                    },
                                  }),
                                  _vm._v(_vm._s(_vm.$t("patch_delete"))),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              staticClass: "wl-green svg-btn",
                              attrs: {
                                disabled: !_vm.hasPermission("download"),
                              },
                              on: { click: _vm.exportMatterLog },
                            },
                            [
                              _c("img", {
                                staticClass: "btn-icon",
                                attrs: {
                                  src: require("@/assets/img/icon-export.svg"),
                                  width: "100%",
                                },
                              }),
                              _vm._v(_vm._s(_vm.$t("COMMON_EXPORT"))),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        class: ["table-container-wrapper", _vm.getTableHeight],
                      },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading",
                              },
                            ],
                            ref: "multipleTable",
                            attrs: {
                              height: "100%",
                              data: _vm.data,
                              border: "",
                              stripe: "",
                            },
                            on: {
                              "selection-change": (e) => {
                                _vm.batch.selectRows = e
                              },
                            },
                          },
                          [
                            _vm.batch.show
                              ? _c("el-table-column", {
                                  attrs: { type: "selection", width: "55" },
                                })
                              : _vm._e(),
                            _c("el-table-column", {
                              attrs: {
                                prop: "entityList",
                                align: "center",
                                label: _vm.$t("TABLE_HEADER_entityList"),
                                "show-overflow-tooltip": "",
                                width: "200px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return _vm._l(
                                        scope.row.entityList,
                                        function (item, index) {
                                          return _c("span", { key: index }, [
                                            index ==
                                            scope.row.entityList.length - 1
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.entityName)
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.entityName) +
                                                      "/"
                                                  ),
                                                ]),
                                          ])
                                        }
                                      )
                                    },
                                  },
                                ],
                                null,
                                false,
                                1632597467
                              ),
                            }),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  prop: "title",
                                  align: "center",
                                  width: "200px",
                                  "show-overflow-tooltip": "",
                                  label: _vm.$t("TABLE_HEADER_matter"),
                                },
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-with-popup" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t("TABLE_HEADER_matter")
                                          ) +
                                          "\n                                    "
                                      ),
                                      _c("MultiSelectPopver", {
                                        attrs: {
                                          hidePopperSearch:
                                            _vm.hidePopperSearch,
                                          value: _vm.search.data.title,
                                          labelKey: "v",
                                          valueKey: "v",
                                          inputFilterKey: ["v"],
                                          options: _vm.titleOptions.map(
                                            (v, k) => ({ v, k })
                                          ),
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.search.data,
                                              "title",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  align: "center",
                                  label: _vm.$t("TABLE_HEADER_Deficiency"),
                                  width: "150px",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mapMatterData[
                                                  scope.row.typeDesc
                                                ]
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1193122942
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-with-popup" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t("FORM_LABEL_matterType")
                                          ) +
                                          "\n                                    "
                                      ),
                                      _c("MultiSelectPopver", {
                                        attrs: {
                                          hidePopperSearch:
                                            _vm.hidePopperSearch,
                                          value: _vm.search.data.matterType,
                                          labelKey: "label",
                                          valueKey: "value",
                                          inputFilterKey: ["value", "label"],
                                          options: _vm.matterLogTypeDescs,
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.search.data,
                                              "matterType",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  align: "center",
                                  prop: "matterDesc",
                                  width: "300px",
                                  "show-overflow-tooltip": "",
                                },
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-with-popup" },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("TABLE_HEADER_Description")
                                          ),
                                        },
                                      }),
                                      _c("MultiSelectPopver", {
                                        attrs: {
                                          hidePopperSearch:
                                            _vm.hidePopperSearch,
                                          value: _vm.search.data.matterDesc,
                                          labelKey: "v",
                                          valueKey: "v",
                                          inputFilterKey: ["v"],
                                          options: _vm.matterDescOptions.map(
                                            (v, k) => ({ v, k })
                                          ),
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.search.data,
                                              "matterDesc",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  prop: "category",
                                  align: "center",
                                  width: "150px",
                                  label: _vm.$t("TABLE_HEADER_category"),
                                },
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-with-popup" },
                                    [
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("TABLE_HEADER_category")
                                          ),
                                        },
                                      }),
                                      _c("MultiSelectPopver", {
                                        attrs: {
                                          hidePopperSearch:
                                            _vm.hidePopperSearch,
                                          value: _vm.search.data.category,
                                          labelKey: "label",
                                          valueKey: "value",
                                          inputFilterKey: ["value", "label"],
                                          options: _vm.matterlogCategorys,
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.search.data,
                                              "category",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: _vm.$t("FORM_LABEL_priority"),
                                width: "130px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "header-with-popup" },
                                          [
                                            _vm.getUser.userType == 1
                                              ? _c(
                                                  "el-dropdown",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "5px",
                                                    },
                                                    on: {
                                                      command:
                                                        _vm.batchChangePriority,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "el-dropdown-link",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-edit-outline table-header-edit-cls",
                                                          attrs: {
                                                            title: _vm.$t(
                                                              "FORM_LABEL_clientOwner"
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-dropdown-menu",
                                                      {
                                                        attrs: {
                                                          slot: "dropdown",
                                                        },
                                                        slot: "dropdown",
                                                      },
                                                      _vm._l(
                                                        _vm.priority,
                                                        function (v) {
                                                          return _c(
                                                            "el-dropdown-item",
                                                            {
                                                              key: v.value,
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                              },
                                                              attrs: {
                                                                command:
                                                                  v.value,
                                                                value: v.value,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(v.label)
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t("FORM_LABEL_priority")
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c("MultiSelectPopver", {
                                              attrs: {
                                                hidePopperSearch:
                                                  _vm.hidePopperSearch,
                                                value:
                                                  _vm.search.data
                                                    .matterPriority,
                                                labelKey: "label",
                                                valueKey: "value",
                                                inputFilterKey: [
                                                  "value",
                                                  "label",
                                                ],
                                                options: _vm.allPriority,
                                              },
                                              on: {
                                                "update:value": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.search.data,
                                                    "matterPriority",
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm.getUser.userType == 1
                                          ? _c(
                                              "el-select",
                                              {
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.updateMatterLogSingleCell(
                                                      scope.row,
                                                      "matterPriority"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    scope.row.matterPriority,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "matterPriority",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.matterPriority",
                                                },
                                              },
                                              _vm._l(
                                                _vm.priority,
                                                function (v, k) {
                                                  return _c("el-option", {
                                                    key: k,
                                                    attrs: {
                                                      value: v.value,
                                                      label: v.label,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.priority
                                                      .map((v) => v.value)
                                                      .includes(
                                                        scope.row.matterPriority
                                                      )
                                                      ? _vm.$t(
                                                          _vm.priority.find(
                                                            (v) =>
                                                              v.value ==
                                                              scope.row
                                                                .matterPriority
                                                          ).label
                                                        )
                                                      : ""
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4061009316
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "typeDesc",
                                align: "center",
                                label: _vm.$t("TABLE_HEADER_Issues"),
                                width: "170px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "header-with-popup" },
                                          [
                                            _vm.getUser.userType == 1
                                              ? _c(
                                                  "el-dropdown",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "5px",
                                                    },
                                                    on: {
                                                      command:
                                                        _vm.batchChangeTypeDesc,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "el-dropdown-link",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-edit-outline table-header-edit-cls",
                                                          attrs: {
                                                            title: _vm.$t(
                                                              "TABLE_HEADER_Issues"
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-dropdown-menu",
                                                      {
                                                        attrs: {
                                                          slot: "dropdown",
                                                        },
                                                        slot: "dropdown",
                                                      },
                                                      _vm._l(
                                                        _vm.statusDict,
                                                        function (v) {
                                                          return _c(
                                                            "el-dropdown-item",
                                                            {
                                                              key: v.value,
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                              },
                                                              attrs: {
                                                                command:
                                                                  v.value,
                                                                value: v.value,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    v.label
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t("TABLE_HEADER_Issues")
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c("MultiSelectPopver", {
                                              attrs: {
                                                hidePopperSearch:
                                                  _vm.hidePopperSearch,
                                                value: _vm.chooseStatus,
                                                labelKey: "xlabel",
                                                valueKey: "value",
                                                inputFilterKey: [
                                                  "value",
                                                  "xlabel",
                                                ],
                                                options: _vm.statusDict.map(
                                                  (v) => ({
                                                    xlabel: _vm.$t(v.label),
                                                    ...v,
                                                  })
                                                ),
                                              },
                                              on: {
                                                "update:value": function (
                                                  $event
                                                ) {
                                                  _vm.chooseStatus = $event
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm.getUser.userType == 1
                                          ? _c(
                                              "el-dropdown",
                                              {
                                                on: {
                                                  command: (value) =>
                                                    _vm.updateMatterLogSingleCellBtDropdown(
                                                      value,
                                                      scope.row.attachmentList
                                                    ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-dropdown-link",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "status-icon",
                                                      attrs: {
                                                        src: _vm.getIconSvg(
                                                          _vm.showStatus(
                                                            scope.row
                                                          )
                                                        ),
                                                        width: "100%",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "el-dropdown-menu",
                                                  {
                                                    attrs: { slot: "dropdown" },
                                                    slot: "dropdown",
                                                  },
                                                  _vm._l(
                                                    _vm.statusDict,
                                                    function (v, k) {
                                                      return _c(
                                                        "el-dropdown-item",
                                                        {
                                                          key: k,
                                                          attrs: {
                                                            value: v.value,
                                                            command: `${v.value}|matterStatus|${scope.row.id}`,
                                                          },
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "status-icon",
                                                            attrs: {
                                                              src: _vm.getIconSvg(
                                                                _vm.showStatus({
                                                                  matterStatus:
                                                                    v.value,
                                                                })
                                                              ),
                                                              width: "100%",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _c("img", {
                                              staticClass: "status-icon",
                                              attrs: {
                                                src: _vm.getIconSvg(
                                                  _vm.showStatus(scope.row)
                                                ),
                                                width: "100%",
                                              },
                                            }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2781583724
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "kpmgUserName",
                                align: "center",
                                width: "150px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "header-with-popup" },
                                          [
                                            _vm.getUser.userType == 1
                                              ? _c(
                                                  "el-dropdown",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "5px",
                                                    },
                                                    on: {
                                                      command:
                                                        _vm.batchChangeKpmgUserName,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "el-dropdown-link",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-edit-outline table-header-edit-cls",
                                                          attrs: {
                                                            title: _vm.$t(
                                                              "FORM_LABEL_kpmgOwner"
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-dropdown-menu",
                                                      {
                                                        attrs: {
                                                          slot: "dropdown",
                                                        },
                                                        slot: "dropdown",
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            size: "mini",
                                                            placeholder: _vm.$t(
                                                              "FORM_LABEL_kpmgOwner"
                                                            ),
                                                            clearable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.kpmgOwnerDropdownFilterInput,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.kpmgOwnerDropdownFilterInput =
                                                                $$v
                                                            },
                                                            expression:
                                                              "kpmgOwnerDropdownFilterInput",
                                                          },
                                                        }),
                                                        _vm._l(
                                                          _vm.kpmgOwnerListDropdown,
                                                          function (v) {
                                                            return _c(
                                                              "el-dropdown-item",
                                                              {
                                                                key: v.id,
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                },
                                                                attrs: {
                                                                  command: v.id,
                                                                  value: v.id,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    `${v.userName}（${v.profitCenter}）`
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t("FORM_LABEL_kpmgOwner")
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c("MultiSelectPopver", {
                                              attrs: {
                                                hidePopperSearch:
                                                  _vm.hidePopperSearch,
                                                value:
                                                  _vm.search.data.kpmgOwner,
                                                labelKey: "xlabel",
                                                valueKey: "id",
                                                inputFilterKey: [
                                                  "id",
                                                  "xlabel",
                                                ],
                                                options: _vm.kpmgOwnerList.map(
                                                  (v) => ({
                                                    xlabel: `${v.userName} ( ${v.profitCenter} ) `,
                                                    ...v,
                                                  })
                                                ),
                                              },
                                              on: {
                                                "update:value": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.search.data,
                                                    "kpmgOwner",
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm.getUser.userType == 1
                                          ? _c(
                                              "el-select",
                                              {
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.updateMatterLogSingleCell(
                                                      scope.row,
                                                      "kpmgUser"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.kpmgOwner,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "kpmgOwner",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.kpmgOwner",
                                                },
                                              },
                                              _vm._l(
                                                _vm.kpmgOwnerList,
                                                function (v, k) {
                                                  return _c("el-option", {
                                                    key: k,
                                                    attrs: {
                                                      value: v.id,
                                                      label: `${v.userName}（${v.profitCenter}）`,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    scope.row.kpmgUserName
                                                      ? scope.row.kpmgUserName
                                                      : "-"
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4189662586
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", width: "150px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "header-with-popup" },
                                          [
                                            _vm.getUser.userType == 1
                                              ? _c(
                                                  "el-dropdown",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "5px",
                                                    },
                                                    on: {
                                                      command:
                                                        _vm.batchChangeClientUserName,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "el-dropdown-link",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-edit-outline table-header-edit-cls",
                                                          attrs: {
                                                            title: _vm.$t(
                                                              "FORM_LABEL_clientOwner"
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-dropdown-menu",
                                                      {
                                                        attrs: {
                                                          slot: "dropdown",
                                                        },
                                                        slot: "dropdown",
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            size: "mini",
                                                            placeholder: _vm.$t(
                                                              "FORM_LABEL_clientOwner"
                                                            ),
                                                            clearable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.clientOwnerDropdownFilterInput,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.clientOwnerDropdownFilterInput =
                                                                $$v
                                                            },
                                                            expression:
                                                              "clientOwnerDropdownFilterInput",
                                                          },
                                                        }),
                                                        _vm._l(
                                                          _vm.clientOwnerListDropdown,
                                                          function (v, k) {
                                                            return _c(
                                                              "el-dropdown-item",
                                                              {
                                                                key: k,
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                },
                                                                attrs: {
                                                                  command:
                                                                    v.userId,
                                                                  value:
                                                                    v.userId,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    v.label
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "FORM_LABEL_clientOwner"
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c("MultiSelectPopver", {
                                              attrs: {
                                                hidePopperSearch:
                                                  _vm.hidePopperSearch,
                                                value:
                                                  _vm.search.data.clientOwner,
                                                labelKey: "label",
                                                valueKey: "userId",
                                                inputFilterKey: [
                                                  "userId",
                                                  "label",
                                                ],
                                                options:
                                                  _vm.clientUserSelectDataFix,
                                              },
                                              on: {
                                                "update:value": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.search.data,
                                                    "clientOwner",
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm.getUser.userType == 1
                                          ? _c(
                                              "el-select",
                                              {
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.updateMatterLogSingleCell(
                                                      scope.row,
                                                      "clientUser"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.clientOwner,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "clientOwner",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.clientOwner",
                                                },
                                              },
                                              _vm._l(
                                                _vm.clientUserSelectDataFix,
                                                function (v, k) {
                                                  return _c("el-option", {
                                                    key: k,
                                                    attrs: {
                                                      value: v.userId,
                                                      label: v.label,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.clientOwnerList
                                                    .map((v) => v.userId)
                                                    .includes(
                                                      scope.row.clientOwner
                                                    )
                                                    ? (() => {
                                                        const _c =
                                                          _vm.clientOwnerList.find(
                                                            (v) =>
                                                              v.userId ==
                                                              scope.row
                                                                .clientOwner
                                                          )
                                                        return !!_c
                                                          ? `<div>${_c.userName}</div><div>(${_c.email})</div>`
                                                          : "-"
                                                      })()
                                                    : "-"
                                                ),
                                              },
                                            }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1256664492
                              ),
                            }),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  align: "center",
                                  label: _vm.$t("Created_Date"),
                                  width: "120px",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  scope.row.createDateStamp
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1211078072
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-with-popup" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.$t("create_date")) +
                                          "\n                                    "
                                      ),
                                      _c("DatePickerPopover", {
                                        attrs: {
                                          value: _vm.search.data.createDate,
                                          hidePopperSearch:
                                            _vm.hidePopperSearch,
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.search.data,
                                              "createDate",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  prop: "createBy",
                                  align: "center",
                                  label: _vm.$t("SITE_TABLE_HEADER_CREATE_BY"),
                                  width: "150px",
                                },
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-with-popup" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "SITE_TABLE_HEADER_CREATE_BY"
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                      _c("MultiSelectPopver", {
                                        attrs: {
                                          hidePopperSearch:
                                            _vm.hidePopperSearch,
                                          value: _vm.search.data.createBy,
                                          labelKey: "xlabel",
                                          valueKey: "id",
                                          inputFilterKey: ["xlabel", "id"],
                                          options: _vm.kpmgOwnerList
                                            .filter((v) => v.id != "Blank")
                                            .map((v) => ({
                                              xlabel: `${v.userName}（${v.profitCenter}）`,
                                              id: v.userAccount,
                                            })),
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.search.data,
                                              "createBy",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _c("el-table-column", {
                              attrs: { align: "center", width: "130px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "header-with-popup" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "SITE_TABLE_HEADER_MODIFIED_TIME"
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "bottom",
                                                  trigger: "click",
                                                  "visible-arrow": false,
                                                },
                                                on: {
                                                  hide: _vm.hidePopperSearch,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "reference",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "th-filter-down",
                                                            },
                                                            [
                                                              _c("i", {
                                                                class: [
                                                                  "el-icon-arrow-down",
                                                                  _vm.dateRange
                                                                    .length > 0
                                                                    ? "el-icon-arrow-down-active"
                                                                    : "",
                                                                ],
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  2796587331
                                                ),
                                              },
                                              [
                                                [
                                                  _c("el-date-picker", {
                                                    staticClass:
                                                      "search-item input-with-select",
                                                    attrs: {
                                                      type: "daterange",
                                                      "range-separator": "~",
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      "start-placeholder":
                                                        _vm.$t(
                                                          "SITE_TABLE_HEADER_MODIFIED_TIME"
                                                        ),
                                                      "end-placeholder": _vm.$t(
                                                        "SITE_TABLE_HEADER_MODIFIED_TIME"
                                                      ),
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value: _vm.dateRange,
                                                      callback: function ($$v) {
                                                        _vm.dateRange = $$v
                                                      },
                                                      expression: "dateRange",
                                                    },
                                                  }),
                                                ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("formatDate")(
                                                scope.row.updateDateStamp
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3338828849
                              ),
                            }),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  prop: "updateBy",
                                  align: "center",
                                  label: _vm.$t(
                                    "SITE_TABLE_HEADER_MODIFIED_BY"
                                  ),
                                  width: "150px",
                                },
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-with-popup" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "SITE_TABLE_HEADER_MODIFIED_BY"
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                      _c("MultiSelectPopver", {
                                        attrs: {
                                          hidePopperSearch:
                                            _vm.hidePopperSearch,
                                          value: _vm.search.data.updateBy,
                                          labelKey: "xlabel",
                                          valueKey: "id",
                                          inputFilterKey: ["xlabel", "id"],
                                          options: _vm.kpmgOwnerList
                                            .filter((v) => v.id != "Blank")
                                            .map((v) => ({
                                              xlabel: `${v.userName}（${v.profitCenter}）`,
                                              id: v.userAccount,
                                            })),
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.search.data,
                                              "updateBy",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                width: "120",
                                fixed: "right",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "header-with-popup" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "TABLE_HEADER_fileNameList"
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "bottom",
                                                  trigger: "click",
                                                  "visible-arrow": false,
                                                },
                                                on: {
                                                  hide: _vm.hidePopperSearch,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "reference",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "th-filter-down",
                                                            },
                                                            [
                                                              _c("i", {
                                                                class: [
                                                                  "el-icon-arrow-down",
                                                                  _vm.search
                                                                    .data
                                                                    .searchContent
                                                                    ? "el-icon-arrow-down-active"
                                                                    : "",
                                                                ],
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1882982893
                                                ),
                                              },
                                              [
                                                [
                                                  _c("el-input", {
                                                    staticClass:
                                                      "search-item input-with-select",
                                                    attrs: {
                                                      size: "medium",
                                                      placeholder:
                                                        _vm.$t(
                                                          "fileNameKeyword"
                                                        ),
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.search.data
                                                          .searchContent,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.search.data,
                                                          "searchContent",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "search.data.searchContent",
                                                    },
                                                  }),
                                                ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  scope.row.attachmentList &&
                                                  scope.row.attachmentList
                                                    .length > 0,
                                                expression:
                                                  "scope.row.attachmentList && scope.row.attachmentList.length > 0",
                                              },
                                            ],
                                            staticClass: "table-filelength",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onFileLengthClick(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  scope.row.attachmentList
                                                    .length
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2053608655
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: _vm.$t("COMMON_UPLOAD"),
                                width: "70",
                                fixed: "right",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("i", {
                                          class: [
                                            _vm.hasPermission("upload")
                                              ? "wl-icon-upload"
                                              : "wl-icon-not-upload",
                                            "el-icon-upload",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.onUploadClick(
                                                scope.row
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                750763062
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: _vm.$t("TABLE_HEAD_COMMENTS"),
                                width: "100",
                                fixed: "right",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "header-with-popup" },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$t("TABLE_HEAD_COMMENTS")
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("DatePickerPopover", {
                                              attrs: {
                                                value:
                                                  _vm.search.data.commentDate,
                                                hidePopperSearch:
                                                  _vm.hidePopperSearch,
                                              },
                                              on: {
                                                "update:value": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.search.data,
                                                    "commentDate",
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex item-center justify-center",
                                          },
                                          [
                                            _c("i", {
                                              class: [
                                                scope.row.todayCommentCount > 0
                                                  ? "wl-icon-messageBoard"
                                                  : "wl-icon-messageBoardNull",
                                                "el-icon-s-comment",
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onCommentClick(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            }),
                                            scope.row.todayCommentCount
                                              ? _c("span", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "message-today",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row
                                                            .todayCommentCount
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "/ \n                                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            scope.row.commentList.length > 0
                                              ? _c("span", [
                                                  _vm._v(
                                                    " \n                                        " +
                                                      _vm._s(
                                                        scope.row.commentList
                                                          .length
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1906115545
                              ),
                            }),
                            _vm.getUser.userType == "1"
                              ? _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    label: _vm.$t("TABLE_HEADER_Action"),
                                    width: "90",
                                    fixed: "right",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-edit-outline wl-icon-edit",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onEditShow(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-delete wl-icon-delete",
                                              staticStyle: {
                                                "margin-left": "10px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDelete(scope.row)
                                                },
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1983991611
                                  ),
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.batch.show
                      ? _c(
                          "div",
                          { staticClass: "batch-operation" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "cancel-btn",
                                attrs: { loading: _vm.batch.loading },
                                on: { click: _vm.onBatchCancel },
                              },
                              [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
                            ),
                            _vm.batch.mode == "delete"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "wl-green",
                                    attrs: {
                                      disabled:
                                        _vm.batch.selectRows.length == 0,
                                      loading: _vm.batch.loading,
                                    },
                                    on: { click: _vm.commitBatchDelete },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("patch_delete")))]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("el-pagination", {
                      staticClass: "wl-pagination",
                      attrs: {
                        "current-page": _vm.pagination.pageNum,
                        "page-size": _vm.pagination.pageSize,
                        "page-sizes": [10, 50, 100],
                        layout: "prev, pager, next, sizes, total",
                        total: _vm.pagination.total,
                      },
                      on: {
                        "current-change": _vm.onCurrentPageChange,
                        "size-change": _vm.onSizeChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _c("add-or-edit", {
            attrs: {
              onRefresh: _vm.getMatterLog,
              onCancel: _vm.onAddOrEditShow,
              onAddOrEdit: _vm.onAddOrEdit,
              data: _vm.current,
            },
          }),
      _c("entity", {
        attrs: { onAdd: _vm.getMatterLog, entityData: _vm.entityData },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("TABLE_HEADER_Message"),
            top: "10vh",
            visible: _vm.comment.show,
            width: "45%",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: { close: _vm.onCommentDialogClose },
        },
        [
          _c(
            "div",
            { staticClass: "messageViewer" },
            [
              _vm._l(_vm.comment.data, function (v, k) {
                return _c(
                  "el-row",
                  { key: k, staticClass: "itemWarp" },
                  [
                    _c(
                      "el-col",
                      {
                        class:
                          v.userType == _vm.getUser.userType
                            ? "floatRight"
                            : "floatLeft",
                        attrs: { span: 18 },
                      },
                      [
                        _c("el-avatar", {
                          class:
                            v.userType == _vm.getUser.userType
                              ? "floatRight"
                              : "floatLeft",
                          attrs: { size: "small", src: _vm.comment.circleUrl },
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "messageWarp",
                            class:
                              v.userType == _vm.getUser.userType
                                ? "floatRight"
                                : "floatLeft",
                          },
                          [
                            _c("div", { staticClass: "messageBy" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(v.commentUser) +
                                  "【"
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDateTime")(v.commentTime)
                                  )
                                ),
                              ]),
                              _vm._v("】\n                            "),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "messageContent",
                                class:
                                  v.userType == _vm.getUser.userAccount
                                    ? "rightMessage"
                                    : "leftMessage",
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(v.comment) +
                                    "\n                                "
                                ),
                                v.createBy === _vm.getUser.userAccount
                                  ? _c(
                                      "el-popconfirm",
                                      {
                                        attrs: {
                                          title: _vm.$t("msg_delete_sure"),
                                        },
                                        on: {
                                          confirm: function ($event) {
                                            return _vm.deleteMessage(v)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-delete deleteButton leftButton",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "addMessage" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  resize: "none",
                  maxlength: "300",
                  "show-word-limit": "",
                  rows: 3,
                  placeholder: _vm.$t("ENTER_MESSAGE_CONTENT"),
                  disabled: _vm.comment.loading,
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    if (
                      $event.ctrlKey ||
                      $event.shiftKey ||
                      $event.altKey ||
                      $event.metaKey
                    )
                      return null
                    return _vm.commentCommit.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.comment.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.comment, "content", $$v)
                  },
                  expression: "comment.content",
                },
              }),
              _c("i", {
                class: [
                  "el-icon-s-promotion",
                  "wl-icon-send",
                  _vm.comment.loading ? "wl-icon-send-disabled" : "",
                ],
                attrs: { title: _vm.$t("comment_send") },
                on: { click: _vm.commentCommit },
              }),
            ],
            1
          ),
        ]
      ),
      _vm.uploadVisible
        ? _c("Upload", {
            ref: "upload",
            attrs: {
              afterDelete: _vm.getMatterLog,
              matterLogId: _vm.matterLogId,
              afterUploadAllFinish: _vm.afterUploadAllFinish,
              initData: _vm.initData,
            },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.fileTable.show,
            title: _vm.$t("FORM_LABEL_attachmentList"),
            top: "10vh",
            width: "70%",
            "close-on-click-modal": false,
            "append-to-body": "",
            "before-close": () => {
              _vm.fileTable.show = false
              _vm.fileTable.limit = 10
              _vm.fileTable.page = 1
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.fileTablePageData,
                "max-height": "500",
                border: "",
                "row-class-name": _vm.tableRowClassName,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  "min-width": "150",
                  label: _vm.$t("DOWNLOAD_FILE_NAME"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: [
                              "file-table-name",
                              _vm.canDownload(scope.row) &&
                              _vm.hasPermission("download")
                                ? "file-table-name-canDownload"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.handleFileClick(scope.row, true)
                              },
                            },
                          },
                          [
                            _vm.canDownload(scope.row) &&
                            _vm.hasPermission("download")
                              ? _c("i", { staticClass: "el-icon-download" })
                              : _vm._e(),
                            _vm._v(
                              "\n                        " +
                                _vm._s(scope.row.name) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("DOWNLOAD_SIZE") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("fileSize")(scope.row.size))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "downloadDate",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("DOWNLOAD_TIME"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "downloadBy",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("DOWNLOAD_BY"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("UPLOAD_BY"),
                  prop: "uploadBy",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("UPLOAD_TIME"),
                  prop: "uploadDate",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "action",
                  width: "70",
                  "show-overflow-tooltip": "",
                  align: "center",
                  label: _vm.$t("COMMON_DELETE"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.noAuthority(scope.row)
                          ? _c("i", {
                              staticClass: "el-icon-delete delete",
                              on: {
                                click: function ($event) {
                                  return _vm.onDeleteClick(scope.row)
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              small: "",
              total: _vm.fileTable.data.length,
              "page-size": _vm.fileTable.limit,
              "page-sizes": [10, 50, 100],
              layout: "prev, pager, next, sizes, total",
            },
            on: {
              "current-change": (e) => (_vm.fileTable.page = e),
              "size-change": (e) => {
                _vm.fileTable.limit = e
                _vm.fileTable.page = 1
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }